// Le Bureau d'études : la table des décisions et l'intake (V4Decisions), le
// dossier d'une décision (V4DecisionDossier).
export default {
  titre: "Bureau d'études",
  enumeration: '{debut} et {fin}',
  citation: '« {texte} »',
  pct: '{n} %',
  // Les trois familles du moteur, et la question que chacune pose.
  famille: {
    tester_concepts: { titre: 'Tester des concepts', question: "Ce concept trouve-t-il son public avant d'engager un euro ?" },
    lancer_positionner: { titre: 'Lancer et positionner', question: 'Quel espace est réellement prenable ?' },
    etendre: { titre: 'Étendre', question: "Jusqu'où s'étirer sans casser le noyau ?" },
  },
  // Les quatre entrées de l'écran.
  entree: {
    ab: {
      titre: 'Comparer des versions (A/B)',
      description: "Deux ou trois versions d'un même objet : un titre, un visuel, une bande-annonce, une accroche. Chaque ISO voit toutes les versions, dans un ordre tiré au sort, puis doit en garder une.",
      exemple: 'Ex. : entre ces deux bandes-annonces de la saison 13, laquelle donne le plus envie de regarder ?',
    },
    concept: {
      titre: 'Tester un concept',
      description: "Un concept, montré à chaque ISO dans son fil : ce qu'il en ferait, et s'il reviendrait. La réception seule, sans arbitrage.",
      exemple: "Ex. : notre série courte « archéologie technique » trouve-t-elle son public avant qu'on engage le budget tournage ?",
    },
    lancer: {
      titre: 'Lancer et positionner',
      description: 'Le Bureau part de ce que votre audience regarde déjà et de ce qui lui manque, puis mesure la réaction à vos pistes de lancement.',
      exemple: "Ex. : on veut ouvrir une chaîne cuisine du quotidien, l'espace est encombré - quel angle reste prenable ?",
    },
    etendre: {
      titre: 'Étendre',
      description: "Le Bureau teste le nouveau format contre le noyau : l'envie de le regarder, l'envie de revenir, et si la chaîne reste celle qu'on suit.",
      exemple: 'Ex. : notre chaîne speedrun peut-elle lancer un format « coulisses » sans perdre ceux qui viennent pour les records ?',
    },
  },
  statut: {
    open: 'en cours',
    decided: 'tranchée',
    abandoned: 'abandonnée',
  },
  enjeu: {
    on_lance: 'On lance ?',
    on_ajuste: 'On ajuste ?',
    on_abandonne: 'On abandonne ?',
    on_arbitre: 'On arbitre ?',
  },
  sousTitre: {
    dossier: 'Dossier {nom} · les décisions de toutes ses marques, chacune avec sa question, ses stimuli et son verdict',
    equipe: "Les dossiers de décision de l'équipe - chaque dossier trace la question, les stimuli et le verdict",
  },
  echeance: {
    trancheeLe: 'tranchée le {date}',
    abandonnee: 'abandonnée',
    aucune: 'sans échéance',
    depassee: 'dépassée de {n} j',
    dans: 'dans {n} j',
  },
  confirmerSuppression: "Supprimer la décision « {titre} » ?\n\nSes stimuli et ses études de panel seront supprimés. Les prédictions déjà inscrites au registre y restent : on n'efface pas une prédiction ratée. Action irréversible.",
  erreur: {
    suppression: 'Suppression impossible',
    imageLourde: 'Image trop lourde (8 Mo max).',
    videoLourde: 'Video trop lourde (2 Go maximum).',
    envoiVideo: 'Envoi de la video impossible : {erreur}',
    lienYoutube: "Seuls les liens YouTube PUBLICS sont acceptés. Pour un autre fichier, utilisez l'envoi.",
    bureauIndisponible: "Le Bureau d'études est indisponible",
    protocoleInacheve: "Le dossier est ouvert, mais le Bureau n'a pas pu finir le protocole : {erreur}",
    creation: 'Création impossible',
    marqueSansDossier: "La marque « {nom} » n'est rangée dans aucun dossier : le Bureau d'études se lit par dossier. Rangez-la depuis la page des dossiers.",
    marqueIntrouvable: 'Cette marque est introuvable : le lien est peut-être ancien, ou la marque appartient à une autre organisation.',
  },
  blocage: {
    videoEnCours: "Une vidéo est encore en cours d'envoi : attendez qu'elle soit arrivée, sinon les ISOs ne la verraient pas.",
    versionVide: '« {nom} » est vide : donnez-lui un contenu - une description, un lien ou un visuel -, ou retirez-la.',
    uneVersion: 'Une version',
    deuxVersions: 'Une comparaison demande au moins deux versions avec un contenu. Décrivez la version B, collez son lien ou ajoutez son visuel.',
    doublon: "Deux versions s'appellent « {nom} » : les ISOs ne pourraient pas dire laquelle ils gardent. Renommez-en une.",
  },
  audience: {
    toutLeDossier: 'tout le dossier',
    laMarque: 'la marque',
    de: "l'audience de {nom}.",
    duDossier: "l'audience de tout le dossier, soit {liste}.",
    seulement: "l'audience de {liste} seulement.",
    seulementPas: "l'audience de {liste} seulement, pas celle de {autres}.",
  },
  liste: {
    dossiers: 'Les dossiers →',
    ouverture: 'Ouverture du Bureau du dossier de cette marque…',
    sansDossier: "Le Bureau d'études se lit par dossier : choisissez-en un dans la barre de gauche. Une décision y interroge l'audience de toutes ses marques, ou de celles que la demande vise.",
    decisions: "Décisions de l'équipe · {n} en cours",
    tri: 'triées par échéance',
    colDecision: 'Décision',
    colFamille: 'Famille',
    colEcheance: 'Échéance',
    colStimuli: 'Stimuli',
    colStatut: 'Statut',
    chargement: 'Chargement…',
    versions: 'versions',
    concept: 'concept',
    indiceSupprimer: 'Supprimer cette décision (stimuli, études de panel). Le registre garde ses prédictions. Irréversible.',
    aucune: 'Aucune décision - ouvrez la première ci-dessous.',
    ouvrir: 'Ouvrir une décision',
    dossierSansMarque: "Ce dossier n'a pas encore de marque : le Bureau interroge l'audience de ses marques. Créez-en une d'abord, depuis la page des dossiers.",
    plusSure: 'la lecture la plus sûre',
    selectionne: 'Sélectionné · décrivez-le ci-dessous',
    comparer: 'Comparer des versions',
    choisirEntree: 'Choisir cette entrée',
    decrire: 'Décrire votre situation',
  },
  intake: {
    titre: "Bureau d'études · nouvelle décision",
    fermer: 'Fermer',
    situation: 'Votre situation, avec vos mots',
    ceQueFera: 'Ce que fera le Bureau :',
    versionsEtape3: "Vous nommerez et décrirez les versions à l'étape 3.",
    exemple: "Ex. : on hésite à lancer une série courte « archéologie technique » au T4 - gros budget tournage, l'équipe est partagée, il nous faut une direction avant fin août…",
    enjeu: "L'enjeu :",
    reformule: "Le Bureau d'études reformule votre demande en décision tranchable - vous validez avant toute étude.",
    indiceQualifier: 'Le Bureau reformule votre demande en question tranchable',
    enReformulation: 'Le Bureau reformule…',
    passer: "Passer au Bureau d'études",
  },
  miroir: {
    titre: "Le miroir - vérifiez qu'on instruit la bonne décision",
    plusProche: 'Voici la version décision la plus proche :',
    multi: 'Si je comprends bien, votre demande contient {n} décisions distinctes - on les instruit une par une. La première :',
    decision: 'Si je comprends bien, la décision à instruire est :',
    quiRepond: 'Qui répond :',
    pourquoi: 'Pourquoi : {texte}',
    pasLaBonne: 'Pas la bonne audience ? Dites-le dans la correction ci-dessous, le Bureau relira la demande.',
    partsEgales: "Chaque communauté garde sa marque et son poids dans l'audience de sa marque ; les marques pèsent à parts égales, faute d'une mesure comparable de la taille de leurs audiences.",
    famille: 'Famille de la décision :',
    lectureBureau: 'lecture du Bureau',
    echeanceLue: '· échéance lue : {date}',
    lirePlutot: 'Le Bureau lit plutôt « {famille} », vous gardez la main.',
    routage: 'Routage à confirmer : choisissez la famille qui convient.',
    exempleCorrection: 'Pas tout à fait ? Dites ce qui cloche, le Bureau reformule…',
    indiceCorriger: 'Corriger la reformulation',
    reformulation: 'reformulation…',
    corriger: 'Corriger',
    revenir: '← revenir à la demande',
    valider: "C'est bien ça",
  },
  stimuli: {
    titreVersions: 'Les versions à comparer, et pour quand',
    titreConcept: 'Le concept à montrer, et pour quand',
    compteurComparaison: '· {n}/{max} - chaque ISO les verra toutes',
    apparieeTitre: 'Comparaison appariée',
    apparieeTexte: 'Chaque ISO voit toutes les versions, dans un ordre tiré au sort, répond pour chacune, puis doit en garder une.',
    apparieePourquoi: "Pourquoi c'est la lecture la plus sûre : dans un plan apparié, le biais propre du moteur frappe chaque version de la même façon et s'annule dans l'écart. Orion est le plus faible sur « quel pourcentage », le plus fort sur « lequel des deux ».",
    receptionTitre: 'Mesure de réception, sans arbitrage',
    receptionTexte: "Chaque ISO réagit à ce seul concept : ce qu'il en ferait dans son fil, et s'il reviendrait. Pour savoir lequel l'emporte, ajoutez une version B - c'est la comparaison qu'Orion mesure le mieux.",
    ajouterB: 'Ajouter une version B pour comparer',
    sansContenu: "Sans contenu à montrer, les ISOs ne répondront qu'aux questions sur leurs habitudes.",
    nomVersion: 'Nom de la version',
    labelCourt: 'Label court',
    indiceNom: 'Le nom que les ISOs liront au moment de choisir - renommez librement',
    exempleContenuVersion: "Ce que les ISOs verront : l'accroche, le pitch - ou un lien, un visuel",
    exempleContenu: 'Description en une phrase',
    visuelMontre: "Visuel montré aux jumeaux pendant l'étude",
    retirerVisuel: 'Retirer le visuel',
    indiceVisuel: "Ajouter un visuel (miniature YouTube, visuel de concept…) - il sera montré aux jumeaux pendant l'étude",
    visuel: 'Visuel',
    retirerVersion: 'Retirer cette version',
    retirerConcept: 'Retirer ce concept',
    videoMontree: "Montree aux jumeaux pendant l'etude - {url}",
    lienYoutube: 'Lien YouTube',
    retirerVideo: 'Retirer la video',
    exempleLien: 'Lien YouTube public (facultatif)',
    indiceLien: 'Seuls les liens PUBLICS fonctionnent : une video non repertoriee est refusee par le modele',
    indiceFichier: 'Envoyer un fichier vidéo (mp4, mov, webm) - 2 Go maximum',
    envoi: 'Envoi…',
    ouFichier: 'ou un fichier',
    nomsArbitrage: "Les ISOs choisiront sur ces noms : préférez un nom qui dit ce qu'est la version (« teaser sombre », « teaser lumineux ») à une simple lettre.",
    ajouterVersion: 'Ajouter une version {lettre}',
    ajouterConcept: 'Ajouter un concept',
    territoires: "Territoires de l'étude :",
    territoiresVises: 'ceux que portent les marques visées, pour nommer le domaine dans les questions',
    territoiresDossier: 'ceux du dossier, pour nommer le domaine dans les questions',
    echeance: 'Échéance :',
    indiceEchantillon: "L'échantillon est dimensionné par la couverture des sous-poches de vos communautés - il n'est jamais choisi à la main",
    echantillon: 'ⓘ échantillon calculé, ancré sur le dernier audit',
    retourMiroir: '← le miroir',
    ouvrirDossier: 'Ouvrir le dossier',
    indiceCreer: 'Ouvre le dossier de décision et son protocole',
    ecritProtocole: 'Le Bureau écrit le protocole…',
    ouvrirDossierDecision: 'Ouvrir le dossier de décision',
    relance: 'Le protocole se relance depuis le dossier.',
  },
  // Le dossier d'une décision (V4DecisionDossier).
  dossier: {
    titre: 'Dossier {ref} · {famille}',
    titreSeul: 'Dossier de décision',
    marquePart: '{nom} ({pct} %)',
    sansPersonasUne: "{nom} n'a pas encore de personas : son audience n'a pas été interrogée, et le verdict ne vaut pas pour elle.",
    sansPersonasPlusieurs: "{noms} n'ont pas encore de personas : leurs audiences n'ont pas été interrogées, et le verdict ne vaut pas pour elles.",
    ouvertLe: 'ouvert le {date}',
    echeance: 'échéance {date}',
    erreur: {
      chargement: 'Chargement impossible',
      demarrage: "L'étude n'a pas démarré : la file est peut-être saturée. Voyez les jobs avant de relancer.",
      generation: 'Génération impossible',
      ajustement: 'Ajustement impossible',
      lancement: 'Lancement impossible',
      confrontation: 'Confrontation impossible',
    },
    progression: {
      instanciation: 'Instanciation du panel…',
      interrogation: 'Interrogation des jumeaux…',
      termine: 'Terminé',
    },
    typeQuestion: {
      stimulus_reaction: 'réaction',
      behavior: 'comportement vécu',
      arbitrage: 'arbitrage',
    },
    confiance: {
      elevee: 'élevée',
      moyenne: 'moyenne',
      faible: 'faible',
    },
    receptivite: {
      indifferent: 'indifférent',
      sceptique: 'sceptique',
      ouvert: 'ouvert',
      enthousiaste: 'enthousiaste',
    },
    jumeau: {
      pourquoi: 'Pourquoi ce choix ?',
      partage: 'À qui le partagerais-tu ?',
    },
    toutes: 'Toutes les décisions',
    questionClient: 'La question du client',
    quiRepond: 'Qui répond :',
    stimuli: 'Stimuli : {liste} - présentés en ordre aléatoire à chaque jumeau.',
    visuelAgrandir: 'Visuel « {nom} » - cliquer pour agrandir',
    protocole: "Protocole · généré par le Bureau d'études",
    verifie: 'protocole vérifié',
    erreurs: '{n} erreur(s)',
    resume: '{q} questions · {n} jumeaux',
    indiceRegles: 'Chaque protocole est vérifié automatiquement : pas de question orientée, échelles équilibrées, options de fuite présentes, ordre aléatoire des stimuli.',
    regles: 'ⓘ 12 règles vérifiées',
    indiceRegenerer: 'Régénère le protocole',
    regeneration: 'régénération…',
    regenerer: 'régénérer',
    voirProtocole: 'voir le protocole',
    replier: 'replier',
    traduitQuestion: "Le Bureau d'études traduit votre question en protocole propre - formulations neutres, échelles avec indifférence, stimuli randomisés :",
    indiceEcrire: 'Le Bureau écrit le protocole de l’étude',
    ecrire: 'Écrire le protocole',
    indiceEchantillon: 'Dimensionné par la couverture des sous-poches de vos communautés - jamais choisi à la main',
    jumeauxEchantillon: 'jumeaux · échantillon calculé',
    communautes: 'communautés',
    stimuliAleatoire: 'stimuli · ordre aléatoire',
    questions: 'questions',
    indiceConcept: 'Question posée pour le concept « {nom} » - chaque concept est vu séparément, en ordre aléatoire',
    exempleAjuster: "Ajuster en langage business - ex. : « insistez sur le prix », « ajoutez l'angle famille »…",
    indiceAjuster: 'Le Bureau retraduit votre demande et revérifie le protocole - les questions ne s’éditent jamais à la main',
    enAjustement: 'le Bureau retraduit…',
    ajuster: 'Ajuster',
    echantillon: 'Échantillon calculé par la couverture des sous-poches · redressé sur les parts mesurées des communautés',
    echantillonPartsEgales: "Échantillon calculé par la couverture des sous-poches · redressé sur les parts mesurées des communautés · les marques à parts égales, faute d'une mesure comparable de la taille de leurs audiences",
    etudeClose: 'Étude close - pour la rejouer, régénérez le protocole : ce sera une nouvelle étude, datée.',
    indiceLancer: 'Chaque jumeau répond individuellement, en aveugle des autres',
    doitEtreVerifie: 'Le protocole doit être vérifié',
    lancer: "Lancer l'étude",
    enErreur: 'Étude en erreur : {message}',
    annulee: "Étude annulée : les jumeaux restants n'ont pas été interrogés.",
    ab: {
      titre: 'Verdict A/B · comparaison appariée',
      net: 'écart net',
      serre: 'écart serré',
      arbitre: '{n} ISOs ont arbitré',
      part: '{nom} : {pct} (redressé) - {n} ISOs',
      aucuneTitre: 'Aucune version gardée, ou « je ne sais pas » : {pct}',
      aucune: 'aucune · ne sait pas',
      ecart: 'écart {a} − {b}',
      zero: 'zéro : aucune différence',
      intervalle: 'Intervalle à ±2σ : de {de} à {a} pts',
      mesure: 'Écart mesuré : {ecart} pts ± {marge}',
      plan: "Chaque ISO a vu toutes les versions, dans un ordre tiré au sort, puis en a gardé une. Dans ce plan apparié, le biais propre du moteur frappe chaque version de la même façon et s'annule dans l'écart : c'est l'écart qu'il faut lire, plus que les pourcentages.",
      marge: "« ± » = deux écarts-types, calculés sur {n} répondants bruts ; le redressement n'y est pas compté, la marge est donc un peu optimiste quand les poids sont très inégaux.",
    },
    verdict: {
      titre: 'Le verdict',
      confiance: 'confiance {niveau}',
      pourquoi: 'ⓘ pourquoi cette confiance',
      closLe: 'étude close le {date}',
      tient: 'Ce qui tient',
      fracture: 'Ce qui se fracture',
      prochaine: 'Prochaine étape →',
      blast: 'Ouvrir le BLAST',
    },
    profilPanel: 'Profil du panel interrogé',
    distributions: {
      titre: 'Distributions',
      global: 'Global (redressé)',
      indiceRedressement: "Redressement : les réponses sont pondérées par la part mesurée de chaque communauté dans l'audience réelle.",
      redresse: 'ⓘ redressé sur les parts mesurées',
      brut: 'ⓘ segment brut, non redressé',
      adhesion: 'adhésion',
      rejet: 'rejet / indifférence',
      nsp: 'je ne sais pas',
      rencontrer: 'Rencontrer des jumeaux de ce segment →',
    },
    verbatims: 'Verbatims · extraits des réponses ouvertes',
    votreDecision: 'Votre décision',
    exempleNote: 'La ligne de recommandation, éditée à votre main - la décision est humaine, elle est juste mieux armée.',
    indiceEnregistrer: 'Enregistre la note de décision',
    enregistrer: 'Enregistrer',
    indiceTrancher: 'Consigne le verdict et clôt la décision',
    trancher: 'Trancher la décision',
    fermer: 'Fermer',
  },
  registre: {
    titre: 'Le registre · prédit vs réel',
    indice: "Chaque prédiction est horodatée et figée au moment de l'étude. La confrontation au réel se fait sur les mesures BLAST / analytics.",
    figees: 'ⓘ prédictions figées, jamais réécrites',
    colPrediction: 'Prédiction',
    colPredit: 'Prédit',
    colReel: 'Réel',
    colEcart: 'Écart',
    colStatut: 'Statut',
    figeeLe: 'figée le {date}',
    confronteeLe: 'confrontée le {date}',
    confiance: 'conf. {niveau}',
    directionnel: 'directionnel',
    exempleFait: 'le fait observé…',
    indiceConfronter: "Inscrit le fait et l'écart - une confrontation ne se réécrit pas",
    confronter: 'Confronter',
    ecart: {
      confirme: 'confirmé',
      nuance: 'nuancé',
      infirme: 'infirmé',
    },
    statut: {
      observed: 'confrontée',
      pending: 'en attente du réel',
      abandoned: 'abandonnée',
    },
  },
}
